import type { FaireProductEntity } from "../../entity_types/product";

export const p_2kxxk8t58u: FaireProductEntity = {
  token: "p_2kxxk8t58u",
  type: "product",
  name: "Assless Chaps - Saddle leather - Coconut Soy 8oz Candle",
  brandToken: "b_f2njjv4jzw",
  brandName: "Milk Jar Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/fa86b9bd7dc191594d718b4bc8f0b701d6c914bf91bf102849b10ca242d44563.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d7bd0171572002ad4f30a5da2fa00a781aa71c7ad8e31a7d90df9aeab3e4de66.jpeg",
    "https://cdn.faire.com/fastly/62ae5b66b7a8e606de6cbf9e20a50c8ed07c3a627ff9ab5796a26e0040682ead.jpeg",
    "https://cdn.faire.com/fastly/85e7941482ea4217108151dab88d926a5c88f1ca972bb3468e0dfe40a961a2f8.jpeg",
    "https://cdn.faire.com/fastly/f3722408d6731c7b7ded340452b4ca198b139e6f46c58af142d731cfa84b9ab5.jpeg",
    "https://cdn.faire.com/fastly/b38de63c17e7c18defbffc7f0d1cdc3933497f831714e8a93fa877cc90f71756.jpeg",
  ],
  priceDollars: 14.32,
  description:
    "Saddle Leather\n\nThere's nothing like the Stampede. The lights, the sounds, the smells. Yes we know that all chaps are assless, but we felt it rolled off the tongue nicely. This candle smells like all the best parts of the rodeo: leather, musk, and a little grit.\n\n$1 from every candle sold supports the creation of inclusive and inviting spaces around the world · Crackling wooden wick · Plant-based coconut soy wax · Scented with high-quality fragrance oils, free from dibutyl phthalates (DBP) and di(2-ethylhexyl) phthalates (DEHP) · Vegan and cruelty-free · 40-45 hour burn time with proper wick trimming · Hand-poured in sunny Calgary",
  tags: [],
  msrpDollars: 30.38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:09.094Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
